/*
 * Cart drawer triggers
 *
 * Opens the custom cart drawer whenever an add-to-cart form posts to /cart/add.
 * This covers Foxify product pages and sticky bar, Globo collection grids, and
 * any other third-party add-to-cart form. Native product forms (product-form.js)
 * are left alone, because they already drive the drawer.
 *
 * Load with defer after cart-drawer.js, e.g. in layout/theme.liquid:
 *   <script defer src="{{ 'cart-drawer-triggers.js' | asset_url }}"></script>
 */
(function () {
  if (window.cartDrawerTriggersLoaded) return;
  window.cartDrawerTriggersLoaded = true;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return false;

    if ((form.method || '').toLowerCase() !== 'post') return false;

    // Leave the native product form and the drawer's own form alone.
        if (form.closest('product-form') || form.id === 'CartDrawer-Form') return false;
    return true;
  }

  function addToCart(form, submitter) {
    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    if (submitter && submitter.name) {
      formData.append(submitter.name, submitter.value || '');
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || 'Add to cart failed');
        return json;
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isAddToCartForm(form)) return;

    // Stop other scripts (including Globo's grid handler) from handling this submit.
    event.preventDefault();
    event.stopImmediatePropagation();

    var submitter = event.submitter || form.querySelector('[type=submit]');
    if (submitter) submitter.setAttribute('aria-disabled', 'true');

    addToCart(form, submitter)
      .then(function (response) {
        var drawer = getDrawer();

        if (!drawer) {
          window.location = window.routes.cart_url;
          return;
        }

              drawer.classList.remove('is-empty');
        drawer.setActiveElement(submitter || document.activeElement);
        drawer.renderContents(response);
        drawer.classList.remove('is-empty');
      })
      .catch(function (error) {
        console.error('Cart drawer: add to cart failed, falling back to a normal submit', error);
        // Fall back to a normal post, so the customer still gets the item or Shopify's error.
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () {
        if (submitter) submitter.removeAttribute('aria-disabled');
      });
  }, true); // Capture phase, so this runs before Globo and Foxify listeners.
})();